import React, { useCallback, useEffect } from 'react'
import UsersTable from './UsersTable/index.jsx'
import ActionButtons from '../components/ActionButtons'
import { useSelector } from 'react-redux'
import _ from 'lodash'
import ReactRouterPrompt from 'react-router-prompt'
import UnsavedDataPopup from '../../../components/UnsavedDataPopup.jsx'
import { useNavigate } from 'react-router-dom'
import axiosInstance from '../../../util/axios.js'

export default function AdminPanelUsers({}) {
	const [userData, setUserData] = React.useState([])
	const [oldUserData, setOldUserData] = React.useState([])
	const [workingOnPage, setWorkingOnPage] = React.useState(false) //required to prevent user actions when data is being updated in background
	const ownId = useSelector((state) => state.user.value.data.id)
	const navigate = useNavigate()

	//for future purpose
	const hasChanged = useCallback(() => {
		return !_.isEqual(userData, oldUserData)
	}, [userData, oldUserData])

	function reloadData() {
		axiosInstance
			.get('/api/users')
			.then((userList) => {
				setUserData(userList['hydra:member'])
				setOldUserData(_.cloneDeep(userList['hydra:member']))
			})
			.catch((e) => {
				console.error(e)
			})
	}

	useEffect(() => {
		reloadData()
	}, [])

	useEffect(() => {
		if (hasChanged()) {
			window.addEventListener('beforeunload', alertUser)
			return () => {
				window.removeEventListener('beforeunload', alertUser)
			}
		}
	}, [hasChanged])

	const alertUser = (e) => {
		e.preventDefault()
		e.returnValue = ''
	}

	const onAddEntryButtonPress = () => {
		setUserData((state) => [
			...state,
			{
				tempId: crypto.randomUUID(),
				username: '',
				email: '',
				phonenumber: '',
				password: '',
			},
		])
	}

	const onSaveButtonPress = () => {
		if (workingOnPage) return

		const promiseList = []

		//check delete
		for (const user of oldUserData) {
			const currentUser = userData.find((e) => e.id == user.id)
			if (!currentUser) {
				promiseList.push(axiosInstance.delete(`/api/users/${user.id}`))
			}
		}

		//check update/create
		for (const user of userData) {
			if (user.id) {
				if (user.id == ownId) continue
				const oldUser = oldUserData.find((e) => e.id === user.id)
				if (!_.isEqual(oldUser, user)) {
					promiseList.push(axiosInstance.patch(`/api/users/${user.id}`, user))
				}
			} else {
				promiseList.push(axiosInstance.post('/api/users', user))
			}
		}

		setWorkingOnPage(true)
		Promise.all(promiseList).then(
			(values) => {
				reloadData()
				setWorkingOnPage(false)
			},
			(reason) => {
				switch (reason.type) {
					case 'EmailInvalidException':
						alert(
							'Eine von Ihnen angegebene Email Adresse ist nicht gültig. Die Daten konnten nicht gespeichert werden.'
						)
						break

					case 'UsernameInvalidException':
						alert(
							'Ein von Ihnen angegebener Benutzername ist nicht gültig (Nutzernamen müssen zwischen 3 und 40 Zeichen lang sein). Die Daten konnten nicht gespeichert werden.'
						)
						break

					case 'NotLoggedInException':
						navigate('/login')
						break

					default:
						alert('Beim Speichern ist ein Fehler aufgetreten.')
				}
				setWorkingOnPage(false)
			}
		)
	}

	return (
		<>
			<ReactRouterPrompt when={hasChanged()}>
				{({ isActive, onConfirm, onCancel }) => (
					<UnsavedDataPopup
						open={isActive}
						onConfirm={onConfirm}
						onCancel={onCancel}
					/>
				)}
			</ReactRouterPrompt>
			<div className='tableContainer'>
				<UsersTable data={userData} setData={setUserData} ownId={ownId} />
			</div>
			<ActionButtons
				onAddButtonPress={onAddEntryButtonPress}
				onSaveButtonPress={onSaveButtonPress}
				pageHasUnsavedChanges={hasChanged}
			/>
		</>
	)
}
